import React from 'react';
import { Form as FormFinal } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { Button, Alert, Spinner } from 'react-bootstrap';
import { Check } from '@styled-icons/boxicons-regular/Check';

//Components
import SessoesForm  from '../../../components/forms/automacao/SessoesForm';

//Helpers
import { TelaModalLivre } from '../../../helpers/TelaModal';

//Tools
import { LogErrorLabels } from '../../../components/forms/utils/toolsforms';

class FormEventos extends React.Component {

    state = {
        showmodalerrors: false
    }

    handleSubmit = async (form) => {
        await this.props.handleSubmit(form);        
    }
            
    handleModalCadastro = (form) => {
        this.props.handleResetReducer();
        this.props.handleResetAlertReducer();
        form.reset();
    }

    handleModalErrors = () => {
        this.setState({
            showmodalerrors: this.state.showmodalerrors?false:true
        });
    }

    handleSubmitLog = () => {
        setTimeout(() => {
            this.handleModalErrors();
        },500);
    }

    handleErrorSubmit = (props) => {
        if(props.submitFailed === true){
            const errors_labels = LogErrorLabels(props);                        
            return (
                <TelaModalLivre titulo="Campos obrigatórios" show={this.state.showmodalerrors} handleCloseModal={this.handleModalErrors}>
                    {errors_labels.map((itens, indice) => {
                        return (                                
                            <Alert variant="warning" key={indice}>{itens}</Alert>
                        )
                    })}
                </TelaModalLivre>
            )
        }
    }

    handleNovo = (form) => {
        this.props.handleResetReducer();
        this.props.handleResetAlertReducer();
        form.reset();
    }
        
    render(){
        return (
            <FormFinal
            validate={this.props.handleValidacao}
            onSubmit={this.handleSubmit}
            initialValues={{...this.props.initialValues}}
            mutators={{                    
                ...arrayMutators,
                setValue: ([field, value], state, { changeValue }) => {
                    changeValue(state, field, () => value)
                }                    
            }}
            render={({ pristine, form, handleSubmit, submitSucceeded, submitFailed, errors }) => {                
                const gravou = submitSucceeded&&this.props.resultcadastro?true:false;
                return (
                <form onSubmit={handleSubmit}>
                    <TelaModalLivre show={gravou} handleCloseModal={() => this.handleModalCadastro(form)}>
                        <Alert variant="success">Finalizado com Sucesso</Alert>
                    </TelaModalLivre>
                    {this.handleErrorSubmit({submitFailed: submitFailed, errors: errors})}
                    {this.props.formcampos&&this.props.formcampos.length?this.props.formcampos.map((sessoesform, index) => {
                        return (
                            <SessoesForm key={index} {...sessoesform} {...this.props} form={form} />
                        );
                    }):null}                    
                    <Button 
                        type="submit"
                        onClick={this.handleSubmitLog}
                        disabled={submitSucceeded || pristine}
                        variant="primary" size="lg" block>
                        <Check size="30" />
                        {this.props.btosubmitlabel}
                        {this.props.pendingTasks?
                        <Spinner animation="border"  />
                        :
                        null
                        }
                    </Button>
                    <Button 
                        type="button"
                        onClick={() => this.handleNovo(form)}
                        variant="primary" size="lg" block>
                        Novo
                    </Button>
                </form>
                )
                }}
            />
        );
    }
}

export default FormEventos;